<template>
	<div class="body">
		<el-container>
			
			<el-header>
				<HeaderCus></HeaderCus>
			</el-header>
			
			<el-main>
				<div class="content_main">
					<div class="mbxdh">
						<el-breadcrumb separator-class="el-icon-arrow-right">
						  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
						  
						  <el-breadcrumb-item :to="{ path: '/list_biaogan'}">标杆企业</el-breadcrumb-item>
						  
						  <el-breadcrumb-item>{{detail.name}}</el-breadcrumb-item>
						  
						</el-breadcrumb>
					</div>
					
					
					<div class="neirong_line">
						<div class="neirong_line_left" style="width: 96%;">
							
							<div class="neirong_line_region">
								<div class="neirong_line_detail_title">
									{{detail.name}}-经营状况及成长性
									<div class="neirong_line_option" v-show="detail.name">
										<el-row>
											<el-col :span="4" :offset="20">
												<el-button icon="el-icon-star-off" type="primary" plain size="mini" v-if="user_collection_detail.id == null" @click="addFav()"> 加入收藏 </el-button>
												<el-button icon="el-icon-star-on" type="primary" plain size="mini" v-if="user_collection_detail.id >0" @click="cancelFav(user_collection_detail.id)"> 已收藏 </el-button>
											</el-col>
										</el-row>
									</div>
								</div>
								<div class="neirong_line_detail_content">
									<el-row :gutter="20">
										<el-col :span="8">
											<div class="detail_company_charts" style="height: 215px;">
												<div id="charts_yysr" style="height: 210px;"></div>
											</div>
										</el-col>
										<el-col :span="8">
											<div class="detail_company_charts" style="height: 215px;">
												<div id="charts_jlr" style="height: 210px;"></div>
											</div>
										</el-col>
										<el-col :span="8">
											<div class="detail_company_charts" style="height: 215px;">
												<div id="charts_mll" style="height: 210px;"></div>
											</div>
										</el-col>
									</el-row>
									<el-row :gutter="20" style="margin-top: 30px;">
										<el-col :span="12">
											<div class="detail_company_charts" style="height: 215px;">
												<div id="charts_jycb" style="height: 210px;"></div>
											</div>
										</el-col>
										<el-col :span="12">
											<div class="detail_company_charts" style="height: 215px;">
												<div id="charts_zczl" style="height: 210px;"></div>
											</div>
										</el-col>
									</el-row>
									<el-row :gutter="20" style="margin-top: 30px;">
										<el-col :span="12">
											<div class="detail_company_charts" style="height: 215px;">
												<div id="charts_cznl" style="height: 210px;"></div>
											</div>
										</el-col>
										<el-col :span="12">
											<div class="detail_company_charts" style="height: 215px;">
												<div id="charts_yfjx" style="height: 210px;"></div>
											</div>
										</el-col>
									</el-row>
									
									<el-row :gutter="20" style="margin-top: 30px;">
										<el-col :span="6">
											<div class="detail_company_charts" style="height: 215px; padding-top: 15px;">
												<div id="charts_ygjy" style="height: 210px;"></div>
											</div>
										</el-col>
										<el-col :span="6">
											<div class="detail_company_charts" style="height: 215px; padding-top: 15px;">
												<div id="charts_ygzy" style="height: 210px;"></div>
											</div>
										</el-col>
										<el-col :span="6">
											<div class="detail_company_charts" style="height: 215px; padding-top: 15px;">
												<div id="charts_mjzj" style="height: 210px;"></div>
											</div>
										</el-col>
										<el-col :span="6">
											<div class="detail_company_charts" style="height: 215px; padding-top: 15px;">
												<div id="charts_zcjg" style="height: 210px;"></div>
											</div>
										</el-col>
									</el-row>
									
								</div>
								
								<!-- <div class="neirong_line_split"></div> -->
							</div>
							
							<div class="neirong_line_split"></div> 
							
							<div class="neirong_line_region">
								<div class="neirong_line_detail_title" v-if="detail.name">
									{{detail.name}}-成长时间轴
								</div>
								<div class="neirong_line_detail_content">
									<div class="detail_company_shijianzhou">
										<el-steps direction="vertical" :space="100">
											<el-step status="finish" v-for="(item, index) in list_step" :key="index" style="flex-basis: 120px;">
												<div slot="title" style="font-size: 18px;" v-if="item.dictIpofileType > 0">【{{getTypeName(item.dictIpofileType)}}】</div>
												<div slot="title" style="font-size: 18px;" v-else>【{{item.name}}】</div>
												
												<div slot="description" style="color: #666; font-size: 14px; margin-top: 9px; cursor: pointer;" v-if="item.dictIpofileType > 0" @click="uDownload(detail.name, item.name, item.pdfFile)">公告文件：{{item.name}}<i class="el-icon-download"></i></div>
												<div slot="description" style="color: #666; font-size: 14px; margin-top: 5px">公告日期：{{item.eventDate}}</div>
											</el-step>
										</el-steps>
									</div>
								</div>
							</div>
							
							<!-- <div class="neirong_line_page">
								这里后期可以关联其它跟本文相关的内容或链接
							</div> -->
						</div>
						
						
						<!-- <div class="neirong_line_right">
							<AdverRightCus></AdverRightCus>
						</div> -->
						
					</div>
					
				</div>
			</el-main>
			
			<el-footer>
				<FooterCus></FooterCus>
			</el-footer>
			
		</el-container>
	</div>
</template>

<script>
	import HeaderCus from '../components/header.vue'
	import FooterCus from '../components/footer.vue'
	import AdverRightCus from '../components/adverRight.vue'
	export default {
		components: {
			HeaderCus,
			FooterCus,
			AdverRightCus,
		},
		data() {
			return {
				detail: {
					id: 0,
				},
				p: '',
				t: '',
				tozgs: '',
				list_step: [],
				user_collection_detail: {},
				
				chart_line_arr1: [0, 0, 0],
				chart_line_arr2: [0, 0, 0],
				chart_line_arr3: [0, 0, 0],
				
				chart_bar_arr1_1: [0, 0, 0],
				chart_bar_arr1_2: [0, 0, 0],
				chart_bar_arr1_3: [0, 0, 0],
				chart_bar_arr2_1: [0, 0, 0],
				chart_bar_arr2_2: [0, 0, 0],
				chart_bar_arr2_3: [0, 0, 0],
				chart_bar_arr3_1: [0, 0, 0],
				chart_bar_arr3_2: [0, 0, 0],
				chart_bar_arr3_3: [0, 0, 0],
				chart_bar_arr4_1: [0, 0, 0],
				chart_bar_arr4_2: [0, 0, 0],
				
				chart_pie_arr1: [0, 0, 0],
				chart_pie_arr2: [0, 0, 0, 0],
				chart_pie_arr3: [0, 0, 0],
				chart_pie_arr4: [0, 0, 0],
				
				
			}
		},
		
		created() {
			this.detail.id = this.$route.query.id
			this.p = this.$route.query.p
			this.t = this.$route.query.t
			this.tozgs = this.$route.query.tozgs
		},
		
		mounted() {
			this.$router.beforeEach((to, from, next) => {
				// console.log(to, from)
				if (to.meta.title) {
					document.title = to.meta.title
				}
				next()
			})
			
			if (this.tozgs == 'zgszcg') {
				// 如果参数传递打开招股说明书则只加载详情和时间线，在时间线中找到招股说明书链接
				this.loadDetail()
				this.loadStep()
			} else {
				// 其它情况则加载全部数据
				this.loadDetail()
				this.loadStep()
				this.loadUserCollection()
				// this.loadCharts()
				this.loadDetailLine();
				this.loadDetailBar();
				this.loadDetailPie();
			}
			
		},
		
		methods: {
			// web配置数据链接跳转
			toUrl(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					this.$router.push({path: url})
				}
			},
			
			// 加载详情
			loadDetail() {
				let url = this.$common.apiUrl + 'pub_company_base/detail/' + this.detail.id
				this.$axios.get(url).then((res)=>{
					console.log(res)
					this.detail = res.data.data
				})
			},
			
			// 加载企业成长线
			loadStep() {
				let url = this.$common.apiUrl + 'pub_company_step/listByComId/' + this.detail.id
				this.$axios.get(url).then((res)=>{
					console.log('成长线数据：', res.data.data)
					this.list_step = res.data.data
					
					this.list_step.forEach((item, index) => {
						if (item.dictIpofileType == 30) {
							// console.log(item)
							let com_name = this.detail.name
							let file_name = item.name
							let file_path = item.pdfFile
							// console.log(file_path)
							if (this.tozgs == 'zgszcg') {
								setTimeout(()=>{
									this.uDownload(com_name, file_name, file_path)
								}, 800)
							}
						}
					})
				})
			},
			
			// 获取ipofile文件类型名称
			getTypeName(t) {
				let label = ''
				if (t == 10) {
					label = '申报稿'
				} else if (t == 20) {
					label = '问询与回复'
				} else if (t == 30) {
					label = '注册稿'
				} else if (t == 99) {
					label = '其它'
				} 
				return label
			},
			
			// 加载用户收藏
			loadUserCollection() {
				let cur_user = JSON.parse(localStorage.getItem('cur_user'));
				if (cur_user) {
					let user_id = cur_user.id;
					let com_id = this.detail.id;
					let url = this.$common.apiUrl + 'pub_user_collection/detailByUserIdComId/' + user_id + '/' + com_id;
					this.$axios.get(url).then((res)=>{
						console.log(res)
						this.user_collection_detail = res.data.data
						// console.log(this.user_collection_detail)
					})
				} else {
					console.log('用户未登录，无法收藏')
				}
			},
			
			// 加入收藏
			addFav() {
				let cur_user = JSON.parse(localStorage.getItem('cur_user'));
				if (cur_user) {
					let user_id = cur_user.id
					let com_id = this.detail.id
					let url = this.$common.apiUrl + 'pub_user_collection/add'
					let client_data = this.$qs.stringify({userId: user_id, userName: cur_user.openidmp, comId: com_id, comName: this.detail.name})
					this.$axios.post(url, client_data).then((res)=>{
						// console.log(res)
						this.$message({
							message: '加入收藏完毕',
							type: 'success',
						});
						this.loadUserCollection()
					})
				} else {
					this.$message.error('用户未登录，无法加入收藏')
					console.log('用户未登录，无法加入收藏')
				}
			},
			
			// 取消收藏
			cancelFav(id) {
				let cur_user = JSON.parse(localStorage.getItem('cur_user'));
				if (cur_user) {
					let url = this.$common.apiUrl + 'pub_user_collection/remove'
					let client_data = this.$qs.stringify({id: id})
					this.$axios.post(url, client_data).then((res)=>{
						// console.log(res)
						this.$message({
							message: '已取消',
							type: 'info',
						});
						this.loadUserCollection()
					})
				} else {
					this.$message.error('用户未登录，无法取消收藏')
					console.log('用户未登录，无法取消收藏')
				}
			},
			
			// 用户点击下载
			uDownload(com_name, file_name, file_path) {
				file_name = com_name + ' | ' + file_name
				file_path = this.$common.file_pdf_wanzheng + file_path
				// console.log('用户下载信息：', file_name, file_path)
				let cur_user = JSON.parse(localStorage.getItem('cur_user'));
				if (cur_user) {
					let url = this.$common.apiUrl + 'pub_user_download/add'
					let client_data = this.$qs.stringify({fileName: file_name, filePath: file_path, userId: cur_user.id})
					this.$axios.post(url, client_data).then((res)=>{
						// console.log(res.data)
						if (res.data.msg.indexOf('ERROR') > -1) {
							this.$message.warning(res.data.msg);
						} else {
							//正常下载链接跳转
							if (this.tozgs == 'zgszcg') {
								// window.open(file_path, '_blank')
								location.href = file_path
							} else {
								window.open(file_path, '_blank')
							}
							
						}
					})
				} else {
					console.log('用户未登录，无法下载')
					this.$message.error('用户未登录，无法继续浏览，请登录会员后浏览和下载')
					setTimeout(() => {
						this.toUrl('/login')
					}, 2500)
				}
			},
			
			
			// 加载折线数据
			loadDetailLine() {
				let url = this.$common.apiUrl + 'pub_company_base/detailLine/' + this.detail.id
				this.$axios.get(url).then((res)=>{
					// console.log(res.data.data)
					this.chart_line_arr1 = res.data.data.arr1
					this.chart_line_arr2 = res.data.data.arr2
					this.chart_line_arr3 = res.data.data.arr3
					this.loadChartsLine();
				})
			},
			// 加载折线图表
			loadChartsLine() {
				var charts_yysr = this.$echarts.init(document.getElementById('charts_yysr'));
				var charts_yysr_option = {
								  title: {
									text: '营业收入统计(万元)',
									subtext: ''
								  },
								  tooltip: {
									trigger: 'axis',
									axisPointer: {
									  type: 'cross',
									  crossStyle: {
										color: '#999'
									  }
									}
								  },
								  toolbox: {
									feature: {
									  dataView: { show: false, readOnly: false },
									  magicType: { show: false, type: ['line', 'bar'] },
									  restore: { show: false },
									  saveAsImage: { show: false }
									}
								  },
								  grid: {
									left: '1%',
									right: '1%',
									top: '28%',
									bottom: '4%',
									containLabel: true,
								  },
								 //  legend: {
									// data: ['销售费用', '研发费用', '财务费用'],
									// x: 'center',
									// y: 'bottom',
								 //  },
								  xAxis: [
									{
									  type: 'category',
									  data: ['第1年度', '第2年度', '第3年度'],
									  axisPointer: {
										type: 'shadow'
									  }
									}
								  ],
								  yAxis: [
									{
									  type: 'value',
									  name: '',
									  axisLabel: {
										formatter: '{value}'
									  },
									  // inerval: 1000,
									  // min: 10,
									  // max: 999999,
									}
								  ],
								  series: [
									{
									  name: '营业收入',
									  type: 'line',
									  barWidth: '25',
									  smooth: true,
									  tooltip: {
										valueFormatter: function (value) {
										  return value;
										}
									  },
									  data: this.chart_line_arr1,
									}
								  ]
				};
				charts_yysr.setOption(charts_yysr_option);
				
				var charts_jlr = this.$echarts.init(document.getElementById('charts_jlr'));
				var charts_jlr_option = {
								  title: {
									text: '净利润走势(万元)',
									subtext: ''
								  },
								  tooltip: {
									trigger: 'axis',
									axisPointer: {
									  type: 'cross',
									  crossStyle: {
										color: '#999'
									  }
									}
								  },
								  toolbox: {
									feature: {
									  dataView: { show: false, readOnly: false },
									  magicType: { show: false, type: ['line', 'bar'] },
									  restore: { show: false },
									  saveAsImage: { show: false }
									}
								  },
								  grid: {
									left: '1%',
									right: '1%',
									top: '28%',
									bottom: '4%',
									containLabel: true,
								  },
								 //  legend: {
									// data: ['销售费用', '研发费用', '财务费用'],
									// x: 'center',
									// y: 'bottom',
								 //  },
								  xAxis: [
									{
									  type: 'category',
									  data: ['第1年度', '第2年度', '第3年度'],
									  axisPointer: {
										type: 'shadow'
									  }
									}
								  ],
								  yAxis: [
									{
									  type: 'value',
									  name: '',
									  axisLabel: {
										formatter: '{value}'
									  },
									  // inerval: 1000,
									  // min: 10,
									  // max: 999999,
									}
								  ],
								  series: [
									{
									  name: '净利润',
									  type: 'line',
									  barWidth: '25',
									  smooth: true,
									  tooltip: {
										valueFormatter: function (value) {
										  return value;
										}
									  },
									  data: this.chart_line_arr2,
									}
								  ]
				};
				charts_jlr.setOption(charts_jlr_option);
				
				var charts_mll = this.$echarts.init(document.getElementById('charts_mll'));
				var charts_mll_option = {
								  title: {
									text: '毛利率走势(%)',
									subtext: ''
								  },
								  tooltip: {
									trigger: 'axis',
									axisPointer: {
									  type: 'cross',
									  crossStyle: {
										color: '#999'
									  }
									}
								  },
								  toolbox: {
									feature: {
									  dataView: { show: false, readOnly: false },
									  magicType: { show: false, type: ['line', 'bar'] },
									  restore: { show: false },
									  saveAsImage: { show: false }
									}
								  },
								  grid: {
									left: '1%',
									right: '1%',
									top: '28%',
									bottom: '4%',
									containLabel: true,
								  },
								 //  legend: {
									// data: ['销售费用', '研发费用', '财务费用'],
									// x: 'center',
									// y: 'bottom',
								 //  },
								  xAxis: [
									{
									  type: 'category',
									  data: ['第1年度', '第2年度', '第3年度'],
									  axisPointer: {
										type: 'shadow'
									  }
									}
								  ],
								  yAxis: [
									{
									  type: 'value',
									  name: '',
									  axisLabel: {
										formatter: '{value}'
									  },
									  // inerval: 1000,
									  // min: 10,
									  // max: 999999,
									}
								  ],
								  series: [
									{
									  name: '营业收入',
									  type: 'line',
									  barWidth: '25',
									  smooth: true,
									  tooltip: {
										valueFormatter: function (value) {
										  return value;
										}
									  },
									  data: this.chart_line_arr3,
									}
								  ]
				};
				charts_mll.setOption(charts_mll_option);
				

			},
			
			// 加载柱状数据
			loadDetailBar() {
				let url = this.$common.apiUrl + 'pub_company_base/detailBar/' + this.detail.id
				this.$axios.get(url).then((res)=>{
					console.log(res.data.data)
					this.chart_bar_arr1_1 = res.data.data.arr1
					this.chart_bar_arr1_2 = res.data.data.arr2
					this.chart_bar_arr1_3 = res.data.data.arr3
					this.chart_bar_arr2_1 = res.data.data.arr4
					this.chart_bar_arr2_2 = res.data.data.arr5
					this.chart_bar_arr2_3 = res.data.data.arr6
					this.chart_bar_arr3_1 = res.data.data.arr7
					this.chart_bar_arr3_2 = res.data.data.arr8
					this.chart_bar_arr3_3 = res.data.data.arr9
					this.chart_bar_arr4_1 = res.data.data.arr10
					this.chart_bar_arr4_2 = res.data.data.arr11
					this.loadChartsBar()
				})
			},
			// 加载柱状图表
			loadChartsBar() {
				var charts_jycb = this.$echarts.init(document.getElementById('charts_jycb'));
				var charts_jycb_option = {
								  title: {
									text: '经营成本统计(万元)',
									subtext: ''
								  },
								  tooltip: {
									trigger: 'axis',
									axisPointer: {
									  type: 'cross',
									  crossStyle: {
										color: '#999'
									  }
									}
								  },
								  toolbox: {
									feature: {
									  dataView: { show: false, readOnly: false },
									  magicType: { show: false, type: ['line', 'bar'] },
									  restore: { show: false },
									  saveAsImage: { show: false }
									}
								  },
								  grid: {
									left: '1%',
									right: '1%',
									top: '28%',
									bottom: '13%',
									containLabel: true,
								  },
								  legend: {
									data: ['销售费用', '研发费用', '财务费用'],
									x: 'center',
									y: 'bottom',
								  },
								  xAxis: [
									{
									  type: 'category',
									  data: ['第1年度', '第2年度', '第3年度'],
									  axisPointer: {
										type: 'shadow'
									  }
									}
								  ],
								  yAxis: [
									{
									  type: 'value',
									  name: '',
									  axisLabel: {
										formatter: '{value}'
									  }
									}
								  ],
								  series: [
									{
									  name: '销售费用',
									  type: 'bar',
									  barWidth: '25',
									  tooltip: {
										valueFormatter: function (value) {
										  return value;
										}
									  },
									  data: this.chart_bar_arr1_1,
									},
									{
									  name: '研发费用',
									  type: 'bar',
									  barWidth: '25',
									  tooltip: {
										valueFormatter: function (value) {
										  return value;
										}
									  },
									  data: this.chart_bar_arr1_2,
									},
									{
									  name: '财务费用',
									  type: 'bar',
									  barWidth: '25',
									  tooltip: {
										valueFormatter: function (value) {
										  return value;
										}
									  },
									  data: this.chart_bar_arr1_3,
									}
								  ]
				};
				charts_jycb.setOption(charts_jycb_option);
				
				var charts_zczl = this.$echarts.init(document.getElementById('charts_zczl'));;
				var charts_zczl_option = {
								  title: {
									text: '资产质量统计(万元)',
									subtext: ''
								  },
								  tooltip: {
									trigger: 'axis',
									axisPointer: {
									  type: 'cross',
									  crossStyle: {
										color: '#999'
									  }
									}
								  },
								  toolbox: {
									feature: {
									  dataView: { show: false, readOnly: false },
									  magicType: { show: false, type: ['line', 'bar'] },
									  restore: { show: false },
									  saveAsImage: { show: false }
									}
								  },
								  grid: {
									left: '1%',
									right: '1%',
									top: '28%',
									bottom: '13%',
									containLabel: true,
								  },
								  legend: {
									data: ['资产总额', '流动资产', '非流动资产'],
									x: 'center',
									y: 'bottom',
								  },
								  xAxis: [
									{
									  type: 'category',
									  data: ['第1年度', '第2年度', '第3年度'],
									  axisPointer: {
										type: 'shadow'
									  }
									}
								  ],
								  yAxis: [
									{
									  type: 'value',
									  name: '',
									  axisLabel: {
										formatter: '{value}'
									  }
									}
								  ],
								  series: [
									{
									  name: '资产总额',
									  type: 'bar',
									  barWidth: '25',
									  tooltip: {
										valueFormatter: function (value) {
										  return value;
										}
									  },
									  data: this.chart_bar_arr2_1,
									},
									{
									  name: '流动资产',
									  type: 'bar',
									  barWidth: '25',
									  tooltip: {
										valueFormatter: function (value) {
										  return value;
										}
									  },
									  data: this.chart_bar_arr2_2,
									},
									{
									  name: '非流动资产',
									  type: 'bar',
									  barWidth: '25',
									  tooltip: {
										valueFormatter: function (value) {
										  return value;
										}
									  },
									  data: this.chart_bar_arr2_3,
									}
								  ]
				};
				charts_zczl.setOption(charts_zczl_option);
				
				var charts_cznl = this.$echarts.init(document.getElementById('charts_cznl'));;
				var charts_cznl_option = {
								  title: {
									text: '偿债能力统计(%)',
									subtext: ''
								  },
								  tooltip: {
									trigger: 'axis',
									axisPointer: {
									  type: 'cross',
									  crossStyle: {
										color: '#999'
									  }
									}
								  },
								  toolbox: {
									feature: {
									  dataView: { show: false, readOnly: false },
									  magicType: { show: false, type: ['line', 'bar'] },
									  restore: { show: false },
									  saveAsImage: { show: false }
									}
								  },
								  grid: {
									left: '1%',
									right: '1%',
									top: '28%',
									bottom: '13%',
									containLabel: true,
								  },
								  legend: {
									data: ['资产负债率', '流动比率', '速动比率'],
									x: 'center',
									y: 'bottom',
								  },
								  xAxis: [
									{
									  type: 'category',
									  data: ['第1年度', '第2年度', '第3年度'],
									  axisPointer: {
										type: 'shadow'
									  }
									}
								  ],
								  yAxis: [
									{
									  type: 'value',
									  name: '',
									  axisLabel: {
										formatter: '{value}'
									  }
									}
								  ],
								  series: [
									{
									  name: '资产负债率',
									  type: 'bar',
									  barWidth: '25',
									  tooltip: {
										valueFormatter: function (value) {
										  return value;
										}
									  },
									  data: this.chart_bar_arr3_1,
									},
									{
									  name: '流动比率',
									  type: 'bar',
									  barWidth: '25',
									  tooltip: {
										valueFormatter: function (value) {
										  return value;
										}
									  },
									  data: this.chart_bar_arr3_2,
									},
									{
									  name: '速动比率',
									  type: 'bar',
									  barWidth: '25',
									  tooltip: {
										valueFormatter: function (value) {
										  return value;
										}
									  },
									  data: this.chart_bar_arr3_3,
									}
								  ]
				};
				charts_cznl.setOption(charts_cznl_option);
				
				var charts_yfjx = this.$echarts.init(document.getElementById('charts_yfjx'));
				var charts_yfjx_option = {
								  title: {
									text: '研发绩效统计(%)',
									subtext: ''
								  },
								  tooltip: {
									trigger: 'axis',
									axisPointer: {
									  type: 'cross',
									  crossStyle: {
										color: '#999'
									  }
									}
								  },
								  toolbox: {
									feature: {
									  dataView: { show: false, readOnly: false },
									  magicType: { show: false, type: ['line', 'bar'] },
									  restore: { show: false },
									  saveAsImage: { show: false }
									}
								  },
								  grid: {
									left: '1%',
									right: '1%',
									top: '28%',
									bottom: '13%',
									containLabel: true,
								  },
								  legend: {
									data: ['研发投入占营收比', '核心产品占收入比'],
									x: 'center',
									y: 'bottom',
								  },
								  xAxis: [
									{
									  type: 'category',
									  data: ['第1年度', '第2年度', '第3年度'],
									  axisPointer: {
										type: 'shadow'
									  }
									}
								  ],
								  yAxis: [
									{
									  type: 'value',
									  name: '',
									  axisLabel: {
										formatter: '{value}'
									  }
									}
								  ],
								  series: [
									{
									  name: '研发投入占营收比',
									  type: 'bar',
									  barWidth: '25',
									  tooltip: {
										valueFormatter: function (value) {
										  return value;
										}
									  },
									  data: this.chart_bar_arr4_1,
									},
									{
									  name: '核心产品占收入比',
									  type: 'bar',
									  barWidth: '25',
									  tooltip: {
										valueFormatter: function (value) {
										  return value;
										}
									  },
									  data: this.chart_bar_arr4_2,
									}
								  ]
				};
				charts_yfjx.setOption(charts_yfjx_option);
			},
			
			// 加载饼状数据
			loadDetailPie() {
				let url = this.$common.apiUrl + 'pub_company_base/detailPie/' + this.detail.id
				this.$axios.get(url).then((res)=>{
					console.log(res.data.data)
					this.chart_pie_arr1 = res.data.data.arr1
					this.chart_pie_arr2 = res.data.data.arr2
					this.chart_pie_arr3 = res.data.data.arr3
					this.chart_pie_arr4 = res.data.data.arr4
					this.loadChartsPie()
				})
			},
			// 加载饼状图表
			loadChartsPie() {
				var charts_ygjy = this.$echarts.init(document.getElementById('charts_ygjy'));
				if (this.chart_pie_arr1[0] == 0 && this.chart_pie_arr1[1] == 0 && this.chart_pie_arr1[2] == 0) {
					this.chart_pie_arr1 = [99999, 99999, 99999]
				}
				var charts_ygjy_option = {
								  title: {
									text: '员工教育程度统计(人)',
									subtext: '',
									left: 'center'
								  },
								  tooltip: {
									trigger: 'item',
									formatter: function (params) {
										// console.log(params)
										let name = params.name
										let val = params.value
										let relVal = ''
										if (val == 99999) {
											relVal = '未采集到数据' 
										} else {
											relVal = name + ': ' + val + ' 人'
										}
										return relVal
									}
								  },
								  legend: {
									orient: 'vertical',
									left: 'left',
									show: false,
								  },
								  series: [
									{
									  name: '',
									  type: 'pie',
									  radius: '60%',
									  center: ['50%', '60%'],
									  data: [
										{ value: this.chart_pie_arr1[0], name: '大专人数' },
										{ value: this.chart_pie_arr1[1], name: '本科人数' },
										{ value: this.chart_pie_arr1[2], name: '硕士及以上' },
									  ],
									  emphasis: {
										itemStyle: {
										  shadowBlur: 10,
										  shadowOffsetX: 0,
										  shadowColor: 'rgba(0, 0, 0, 0.5)'
										}
									  }
									}
								  ]
				};
				charts_ygjy.setOption(charts_ygjy_option);
				
				var charts_ygzy = this.$echarts.init(document.getElementById('charts_ygzy'));
				var charts_ygzy_option = {
								  title: {
									text: '员工专业结构统计(%)',
									subtext: '',
									left: 'center'
								  },
								  tooltip: {
									trigger: 'item',
									formatter: function (params) {
										// console.log(params)
										let name = params.name
										let val = params.value
										let relVal = name + ': ' + val + ' %'
										return relVal
									}
								  },
								  legend: {
									orient: 'vertical',
									left: 'left',
									show: false,
								  },
								  series: [
									{
									  name: '',
									  type: 'pie',
									  radius: '60%',
									  center: ['50%', '60%'],
									  data: [
										{ value: this.chart_pie_arr2[0], name: '销售人员占比' },
										{ value: this.chart_pie_arr2[1], name: '管理人员占比' },
										{ value: this.chart_pie_arr2[2], name: '研发人员占比' },
										{ value: this.chart_pie_arr2[3], name: '生产人员占比' },
									  ],
									  emphasis: {
										itemStyle: {
										  shadowBlur: 10,
										  shadowOffsetX: 0,
										  shadowColor: 'rgba(0, 0, 0, 0.5)'
										}
									  }
									}
								  ]
				};
				charts_ygzy.setOption(charts_ygzy_option);
				
				var charts_mjzj = this.$echarts.init(document.getElementById('charts_mjzj'));
				var qita_val = this.chart_pie_arr3[0] - this.chart_pie_arr3[1] -this.chart_pie_arr3[2];
				var charts_mjzj_option = {
								  title: {
									text: '募集资金用途统计(万元)',
									subtext: '',
									left: 'center'
								  },
								  tooltip: {
									trigger: 'item',
									formatter: function (params) {
										// console.log(params)
										let name = params.name
										let val = params.value
										let relVal = name + ': ' + val + ' 万元'
										return relVal
									}
								  },
								  legend: {
									orient: 'vertical',
									left: 'left',
									show: false,
								  },
								  series: [
									{
									  name: '',
									  type: 'pie',
									  radius: '60%',
									  center: ['50%', '60%'],
									  data: [
										// { value: this.chart_pie_arr3[0], name: '募集资金总额' },
										{ value: this.chart_pie_arr3[1], name: '研发项目支出' },
										{ value: this.chart_pie_arr3[2], name: '补充营运资金' },
										{ value: qita_val, name: '其他' },
									  ],
									  emphasis: {
										itemStyle: {
										  shadowBlur: 10,
										  shadowOffsetX: 0,
										  shadowColor: 'rgba(0, 0, 0, 0.5)'
										}
									  }
									}
								  ]
				};
				charts_mjzj.setOption(charts_mjzj_option);
				
				var charts_zcjg = this.$echarts.init(document.getElementById('charts_zcjg'));
				var charts_zcjg_option = {
								  title: {
									text: '资产结构数据统计(万元)',
									subtext: '',
									left: 'center'
								  },
								  tooltip: {
									trigger: 'item',
									formatter: function (params) {
										// console.log(params)
										let name = params.name
										let val = params.value
										let relVal = name + ': ' + val + ' 万元'
										return relVal
									}
								  },
								  legend: {
									orient: 'vertical',
									left: 'left',
									show: false,
								  },
								  series: [
									{
									  name: '',
									  type: 'pie',
									  radius: '60%',
									  center: ['50%', '60%'],
									  data: [
										// { value: this.chart_pie_arr4[0], name: '资产总额' },
										{ value: this.chart_pie_arr4[1], name: '无形资产' },
										{ value: this.chart_pie_arr4[2], name: '固定资产' },
									  ],
									  emphasis: {
										itemStyle: {
										  shadowBlur: 10,
										  shadowOffsetX: 0,
										  shadowColor: 'rgba(0, 0, 0, 0.5)'
										}
									  }
									}
								  ]
				};
				charts_zcjg.setOption(charts_zcjg_option);
			},
			
			
		}
	}
</script>

<style scoped>
</style>